
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { Modal } from "bootstrap";
import { hideModal } from "@/core/helpers/dom";

const roomcode = ref();
const roomPwd = ref();
const flgPhoto = ref();
const modalPassword = ref<null | HTMLElement>(null);

export default defineComponent({
  name: "my-exam",
  data() {
    return {
      imageUrl: process.env.VUE_APP_IMG_URL,
      passwordFieldType: "password",
      listExamCenter: null as any,
    };
  },
  setup() {
    const router = useRouter();

    const getExamRoomRegister = () => {
      return axios.get(
        process.env.VUE_APP_API_URL +
          "/getExamRoomRegister" +
          "?sizeContents=9&page=0&status=0,1&isDetail=true&userId=" +
          localStorage.getItem("u_id") +
          "&startDateEnter=",
        {
          headers: {
            token: localStorage.getItem("id_token"),
          },
        },
      );
    };

    const enterRoom = async () => {
      const formData = new FormData();
      formData.append("examRoomCode", roomcode!.value + "");
      await axios
        .post(process.env.VUE_APP_API_URL + "/enterExamRoomRegister", formData, {
          headers: {
            token: localStorage.getItem("id_token"),
          },
        })
        .then((response) => {
          if (response.data.code == 200) {
            router.push({
              name: "exam-detail-noheader",
              params: { id: response.data.data.examRoomId },
            });
          } else {
            Swal.fire({
              text: response.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "ลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            text: error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "ลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    };

    return {
      router,
      getExamRoomRegister,
      enterRoom,
      roomcode,
      roomPwd,
      flgPhoto,
      modalPassword,
    };
  },
  async mounted() {
    const modalPasswordEl = document.getElementById("kt_modal_password");
    if (modalPasswordEl) {
      new Modal(modalPasswordEl);
    }
    try {
      const { data } = await this.getExamRoomRegister();
      const content = data?.data?.content || [];
      const list: any = [];
      for (const loopData of content) {
        if (loopData.startTestDate != null) {
          if (
            new Date(loopData.startTestDate).getTime() >
            new Date().setHours(0, 0, 0)
          ) {
            list.push(loopData);
          }
        } else if (loopData.examRoomProfile?.endDate) {
          if (
            new Date(loopData.examRoomProfile.endDate).getTime() >
            new Date().setHours(0, 0, 0)
          ) {
            list.push(loopData);
          }
        }
      }
      this.listExamCenter = list;
    } catch (error) {
      this.listExamCenter = [];
    }
  },
  methods: {
    setAltImg(event) {
      event.target.src = "media/image-app/no-image.svg";
    },
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    formatDateTime(date) {
      const event = new Date(date);
      return (
        event.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }) + " น."
      );
    },
    async registerExamRoom(id, flgPwd, photo, examRoomCode, startDate) {
      console.log("registerExamRoom");
      
      if (startDate && new Date().getTime() >= new Date(startDate).getTime()) {
        roomcode.value = examRoomCode;
        flgPhoto.value = photo;
        if (flgPwd && photo) {
          const myModal = Modal.getInstance(this.$refs.modalPassword as HTMLElement);
          myModal?.show();
        } else if (flgPwd) {
          const myModal = Modal.getInstance(this.$refs.modalPassword as HTMLElement);
          myModal?.show();
        } else if (photo) {
          this.$router.push({
            name: "verify",
            params: { examRoomCode: examRoomCode },
          });
        } else {
          const formData = new FormData();
          formData.append("examRoomCode", examRoomCode + "");
          await axios
            .post(
              process.env.VUE_APP_API_URL + "/enterExamRoomRegister",
              formData,
              {
                headers: {
                  token: localStorage.getItem("id_token"),
                },
              },
            )
            .then((response) => {
              if (response.data.code == 200) {
                console.log("response.data.data.examRoomId", response.data.data);
                this.$router.push({
                  name: "exam-detail-noheader",
                  params: { id: id },
                });
              } else {
                Swal.fire({
                  text: response.data.message,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "ลองใหม่ภายหลัง!",
                  customClass: {
                    confirmButton: "btn fw-semobold btn-light-danger",
                  },
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                text: error.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "ลองใหม่ภายหลัง!",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-danger",
                },
              });
            });
        }
      } else {
        Swal.fire({
          text: "ยังไม่ถึงเวลาเข้าสอบ",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "ลองใหม่ภายหลัง!",
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        });
      }
    },
    async submitPassword() {
      hideModal(this.$refs.modalPassword as HTMLElement);
      const formData = new FormData();
      formData.append("examRoomCode", roomcode!.value + "");
      formData.append("examRoomPwd", roomPwd!.value + "");
      await axios
        .post(process.env.VUE_APP_API_URL + "/checkExamRoomRegister", formData, {
          headers: {
            token: localStorage.getItem("id_token"),
          },
        })
        .then(async (response) => {
          if (response.data.code == 200) {
            if (flgPhoto.value == true) {
              this.$router.push({
                name: "verify",
                params: { examRoomCode: roomcode.value },
              });
            } else {
              await this.enterRoom();
            }
          } else {
            Swal.fire({
              text: response.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "ลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            text: error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "ลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    },
  },
});
